/* eslint-disable */
import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"

// components
import { Button as StyledButton, EmptyStateSearch, FilterListLabel, SectionHeader } from "quorumdesign"
import { DisplayVisualizationsButton } from "app/static/frontend/search-new/containers/FilterableListView/ActionButtons"
import SearchFiltersTextareaFilter from "app/static/frontend/search-new/containers/Filter/SearchFiltersTextareaFilter"

// helpers
import { delay } from "shared/imports/sharedHelperFunctions"
import { QuorumTheme, mobileBreakpoint } from "app/static/frontend/design-constants"
import { combinePersonifiedFilterGroups } from "shared/search/components/FilterableListView/helperFunctions"

export default class FilterSet extends Component {
    static propTypes = {
        // from filtersets.js
        filterGroups: PropTypes.arrayOf(PropTypes.func).isRequired,
        labelPlural: PropTypes.string,
        searchBarComponent: PropTypes.func,
        searchPlaceholderText: PropTypes.string,
        // from filterablelistview
        connectSearchBar: PropTypes.bool,
        isProfile: PropTypes.bool,
        quorumDataType: PropTypes.number,
        uniqueFlvId: PropTypes.string,
        // from shared/search/containers/filterset/index
        filterGlobalButtonDetails: PropTypes.object.isRequired,
        closeAllFilterGroups: PropTypes.func.isRequired,
        // from app/search/containers/filterset/index
        activeActionButton: PropTypes.string,
        filterSetScrollTop: PropTypes.number,
        hasNewFiltersOnInitialLoad: PropTypes.bool.isRequired,
        hasNonProtectedCurrentFilters: PropTypes.bool.isRequired,
        sendAction: PropTypes.func.isRequired,
        setActiveActionButton: PropTypes.func.isRequired,
        setSearchTerm: PropTypes.func.isRequired,
        shouldHideFilters: PropTypes.bool.isRequired,
        storeScrollTopPositions: PropTypes.func.isRequired,
        toggleHideFilterSet: PropTypes.func.isRequired,
        updateUserdata: PropTypes.func.isRequired,
        // searchify
        isSearchifySubmittable: PropTypes.bool,
        searchifyHeaderName: PropTypes.string,
        // selected from the search => props.uniqueFlvId slice of the store
        searchFilterTerm: PropTypes.string,

        isAiSearchApplied: PropTypes.bool,
        aiSearchFilters: PropTypes.object,
        // mobile version props
        areMobileSearchFiltersOpen: PropTypes.bool,
        setMobileFiltersOpenStatus: PropTypes.func,
    }
    state = {
        shouldRenderTextareaEmptyState: false,
        seeMore: false,
    }

    async componentDidMount() {
        if (this.props.filterSetScrollTop && !this.props.hasNewFiltersOnInitialLoad) {
            // if filters were modified by searchify, set the scrolltop.
            this.refs.filterSetScrollContainer.scrollTop = this.props.filterSetScrollTop
        }

        // hacky way to wait for all of the FilterGroupComponent children to
        // "return null" and unmount
        // if they do not contain the current searchFilterTerm from the SearchFiltersTextareaFilter

        // we use the same hack in
        // app/static/frontend/search-new/components/Filter/SearchBarFilter/SearchBarFilter.js
        // to ensure that the SearchBarFilter sets the correct searchTerm value
        await delay(0)
        if (
            !this.state.shouldRenderTextareaEmptyState &&
            // SearchFiltersTextareaFilter
            this.refs.filterSetScrollContainer &&
            // because this.props.filterGroups is an array of wrapped components,
            // we don't know whether or not renderFilterGroups FilterGroupComponent
            // will render null or not until it is inserted into the DOM
            // (see app/static/frontend/search-new/components/FilterSet/ExpandableDropdown/index.js)

            // because of this, we need to explicitly check to see how many elements are being rendered inside of
            // the filterSetScrollContainer to determine whether we need to display the
            // <EmptyStateSearch /> component

            // the value is === 2 because we always render the
            // div.section-header-design-system
            // SearchFiltersTextareaFilter
            // components inside of filterSetScrollContainer no matter what
            this.refs.filterSetScrollContainer.childElementCount === 2
        ) {
            this.setState({
                shouldRenderTextareaEmptyState: true,
            })
        }

        // hide the filter set if the user is on the single note page
        if (
            this.props.quorumDataType === DjangIO.app.models.QuorumDataType.note.value &&
            window.location.search.includes("?id__in=")
        ) {
            this.props.toggleHideFilterSet({
                sendAction: this.props.sendAction,
                shouldHideFilters: true,
                updateUserdata: this.props.updateUserdata,
            })
        }
        // Expands the See More button on mount if a filter is active within any
        // of the filter groups below the button, aka its "fold".
        if (this.props.areBelowSeeMoreFoldFiltersActive && !this.state.seeMore) {
            this.setState({
                seeMore: true,
            })
        }
    }

    async componentDidUpdate() {
        // hacky way to wait for all of the FilterGroupComponent children to
        // "return null" and unmount
        // if they do not contain the current searchFilterTerm from the SearchFiltersTextareaFilter

        // we use the same hack in
        // app/static/frontend/search-new/components/Filter/SearchBarFilter/SearchBarFilter.js
        // to ensure that the SearchBarFilter sets the correct searchTerm value
        await delay(0)

        if (
            !this.state.shouldRenderTextareaEmptyState &&
            // SearchFiltersTextareaFilter
            this.refs.filterSetScrollContainer &&
            // because this.props.filterGroups is an array of wrapped components,
            // we don't know whether or not renderFilterGroups FilterGroupComponent
            // will render null or not until it is inserted into the DOM
            // (see app/static/frontend/search-new/components/FilterSet/ExpandableDropdown/index.js)

            // because of this, we need to explicitly check to see how many elements are being rendered inside of
            // the filterSetScrollContainer to determine whether we need to display the
            // <EmptyStateSearch /> component

            // the value is === 2 because we always render the
            // div.section-header-design-system
            // SearchFiltersTextareaFilter
            // components inside of filterSetScrollContainer no matter what
            this.refs.filterSetScrollContainer.childElementCount === 2
        ) {
            this.setState({
                shouldRenderTextareaEmptyState: true,
            })
        } else if (
            this.state.shouldRenderTextareaEmptyState &&
            // SearchFiltersTextareaFilter
            // EmptyStateSearch
            // to
            // SearchFiltersTextareaFilter
            // FilterGroup1
            // FilterGroup2
            // ...
            this.refs.filterSetScrollContainer &&
            // because this.props.filterGroups is an array of wrapped components,
            // we don't know whether or not renderFilterGroups FilterGroupComponent
            // will render null or not until it is inserted into the DOM
            // (see app/static/frontend/search-new/components/FilterSet/ExpandableDropdown/index.js)

            // because of this, we need to explicitly check to see how many elements are being rendered inside of
            // the filterSetScrollContainer to determine whether we need to display the
            // <EmptyStateSearch /> component

            // the value is === 3 because we always render the
            // div.section-header-design-system
            // SearchFiltersTextareaFilter
            // components inside of filterSetScrollContainer no matter what,
            // so if there are more than 2 elements inside of filterSetScrollContainer,
            // we know that we have valid FilterGroups and should no longer show the <EmptyStateSearch /> component
            this.refs.filterSetScrollContainer.childElementCount > 3
        ) {
            this.setState({
                shouldRenderTextareaEmptyState: false,
            })
        }
    }

    componentWillUnmount() {
        if (!this.props.isSearchifySubmittable && !this.props.isProfile && this.refs.filterSetScrollContainer) {
            this.props.storeScrollTopPositions(this.props.uniqueFlvId, {
                filterSet: this.refs.filterSetScrollContainer.scrollTop,
            })
        }
    }

    toggleSeeMore = () => {
        this.setState((state) => ({
            seeMore: !state.seeMore,
        }))
    }

    clearSearchBar = () => {
        this.props.setSearchTerm(undefined)
    }

    filterButtonOnPress = () => {
        const callback =
            this.props.activeActionButton === DisplayVisualizationsButton.defaultProps.uniqueActionButtonId
                ? () => this.props.setActiveActionButton(this.props.uniqueFlvId, undefined)
                : undefined

        this.props.filterGlobalButtonDetails.onPress(callback)
    }

    shouldShowFilterButton() {
        return this.props.hasNonProtectedCurrentFilters || this.props.hasDefaultFilters
    }

    renderSearchBarComponent() {
        // this is the component that will hook the FLV's filter systems
        // up to the search bar! So we only want it if we actually want the search bar
        // to work in the FLV. Visually, it's an empty div, but it has lifecycle
        // methods that are important.
        const SearchBarComponent = this.props.searchBarComponent
        return (
            <SearchBarComponent
                key="SearchBarComponent"
                uniqueFilterId="AdvancedSearchFilter"
                uniqueFlvId={this.props.uniqueFlvId}
                placeholderText={this.props.searchPlaceholderText}
                isProtected
            />
        )
    }

    renderClearFilterButton() {
        const isMobile = window.innerWidth <= mobileBreakpoint

        return (
            <StyledButton
                style={isMobile ? { color: QuorumTheme.colors.gray[7] } : null}
                hoverable={false}
                onClick={this.filterButtonOnPress}
                text={this.props.filterGlobalButtonDetails.text}
                type="borderless"
            />
        )
    }

    // button not utilized for Design System Search Filters
    renderClearSearchButton() {
        return (
            <Button onClick={this.clearSearchBar} className="clear-filter-button" variant="default">
                Clear Search Text
            </Button>
        )
    }

    renderFilterGroupComponent(filterGroups) {
        return filterGroups.map((item) => {
            const FilterGroupComponent = item
            return (
                <FilterGroupComponent
                    key={FilterGroupComponent.defaultProps.uniqueFilterGroupId}
                    searchFilterTerm={this.props.searchFilterTerm}
                    uniqueFlvId={this.props.uniqueFlvId}
                    isProfile={this.props.isProfile}
                    searchifyHeaderName={this.props.searchifyHeaderName}
                />
            )
        })
    }

    renderAiSearchAppliedFilterGroups() {
        // ai search filter groups will be separated into 2 sections
        // one for ai search applied filter groups, one for the non-ai search applied filter groups
        const aiSearchAppliedFilterGroups = []
        let nonAiSearchAppliedFilterGroups = this.props.filterGroups

        for (const aiSearchFilterId of Object.keys(this.props.aiSearchFilters?.toJS() || {})) {
            // pushing for aiSearchAppliedFilterGroups because we want to accumulate all the filter groups that have been applied
            aiSearchAppliedFilterGroups.push(
                ...this.props.filterGroups.filter((filterGroup) => {
                    // map the filter group's filters to their ids for comparison to aiSearchFilterId
                    let filters = filterGroup.defaultProps?.filters?.map(
                        (filter) => filter.defaultProps?.uniqueFilterId,
                    )

                    // some filters are unconnected filter groups (e.g. custom fields, stakeholder, etc)
                    // the filters for these are the keys of filterKeyMap in the defaultProps
                    // only exception is custom fields, not sure where the filters get loaded and stored
                    if (!filters?.length) {
                        filters = Object.keys(filterGroup.defaultProps?.filterKeyMap || {})
                    }

                    return (
                        filters?.some((filterId) => filterId === aiSearchFilterId) &&
                        !aiSearchAppliedFilterGroups.includes(filterGroup)
                    )
                }),
            )

            nonAiSearchAppliedFilterGroups = nonAiSearchAppliedFilterGroups.filter((filterGroup) => {
                let filters = filterGroup.defaultProps?.filters?.map((filter) => filter.defaultProps?.uniqueFilterId)

                if (!filters?.length) {
                    filters = Object.keys(filterGroup.defaultProps?.filterKeyMap || {})
                }

                return !filters?.some((filterId) => filterId === aiSearchFilterId)
            })
        }

        if (this.state.seeMore) {
            nonAiSearchAppliedFilterGroups = combinePersonifiedFilterGroups(
                nonAiSearchAppliedFilterGroups,
                this.props.seeMoreFilterGroups,
            )
        }

        return (
            <>
                <FilterListLabel aiSearch={true} text="Applied" />
                {this.renderFilterGroupComponent(aiSearchAppliedFilterGroups)}
                <FilterListLabel text="All filters" />
                {this.renderFilterGroupComponent(nonAiSearchAppliedFilterGroups)}
                {this.props.seeMoreFilterGroups?.length ? (
                    <StyledButton
                        hoverable={false}
                        onClick={this.toggleSeeMore}
                        style={{ color: QuorumTheme.colors.secondary[5] }}
                        text={this.state.seeMore ? "See Less" : "See More"}
                        type="borderless"
                    />
                ) : null}
            </>
        )
    }

    renderFilterGroups() {
        let filterGroups = this.props.filterGroups

        if (this.state.seeMore) {
            filterGroups = combinePersonifiedFilterGroups(this.props.filterGroups, this.props.seeMoreFilterGroups)
        }

        filterGroups = this.renderFilterGroupComponent(filterGroups)

        return (
            <>
                {filterGroups}
                {this.props.seeMoreFilterGroups?.length ? (
                    <StyledButton
                        hoverable={false}
                        onClick={this.toggleSeeMore}
                        style={{ color: QuorumTheme.colors.secondary[5] }}
                        text={this.state.seeMore ? "See Less" : "See More"}
                        type="borderless"
                    />
                ) : null}
            </>
        )
    }

    render() {
        const hasFilterGroups = Boolean(this.props.filterGroups.length)
        const isMobile = window.innerWidth <= mobileBreakpoint

        // if no filter groups are provided, then don't bother
        // rendering buttons or groups, only render the search bar.
        if (!hasFilterGroups) {
            return (
                <div className="filter-view-holder no-filters">
                    {this.props.connectSearchBar && this.renderSearchBarComponent()}
                </div>
            )
        }

        const getEmptyStateText = () => {
            if (this.props.quorumDataType) {
                return DjangIO.app.models.QuorumDataType.by_value(this.props.quorumDataType).plural
            } else if (this.props.labelPlural) {
                return this.props.labelPlural
            }

            return "the dataset"
        }

        return (
            <div className="filter-view-holder-design-system">
                {this.props.connectSearchBar && this.renderSearchBarComponent()}
                <div className="filter-view-design-system" ref="filterSetScrollContainer">
                    <div className="section-header-design-system">
                        <div className="section-header-text-design-system">
                            <SectionHeader title="Filters" />
                        </div>
                        <div className="filter-set-buttons-design-system">
                            {this.shouldShowFilterButton() && this.renderClearFilterButton()}
                            {isMobile && this.props.areMobileSearchFiltersOpen && (
                                // close mobile filters button
                                <StyledButton
                                    dataCy="filter-view-hide-button-mobile"
                                    style={{ color: QuorumTheme.colors.gray[7] }}
                                    onClick={() => this.props.setMobileFiltersOpenStatus(false)}
                                    text={"Hide"}
                                    leftIcon={this.props.areMobileSearchFiltersOpen && "arrow-from-right"}
                                    leftIconFamily="far"
                                    type="outlined"
                                    isTiny
                                />
                            )}
                            <StyledButton
                                // This button is for toggling open desktop search filters.
                                // On mobile, we're hiding it when mobile search filters are visible.
                                style={isMobile && this.props.areMobileSearchFiltersOpen ? { display: "none" } : null}
                                dataCy="filter-view-hide-button"
                                isTiny
                                leftIcon="arrow-from-left"
                                leftIconFamily="far"
                                leftIconFlip={!this.props.shouldHideFilters && "horizontal"}
                                leftIconSize="18px"
                                leftIconStyle={{ display: "block" }}
                                onClick={() => {
                                    this.props.toggleHideFilterSet({
                                        sendAction: this.props.sendAction,
                                        shouldHideFilters: !this.props.shouldHideFilters,
                                        updateUserdata: this.props.updateUserdata,
                                    })
                                }}
                                text={this.props.shouldHideFilters ? "Show" : "Hide"}
                                type="outlined"
                            />
                        </div>
                    </div>
                    <SearchFiltersTextareaFilter
                        closeAllFilterGroups={this.props.closeAllFilterGroups}
                        uniqueFlvId={this.props.uniqueFlvId}
                    />
                    {this.state.shouldRenderTextareaEmptyState && (
                        <EmptyStateSearch
                            icon="search"
                            iconFamily="fad"
                            text={
                                `If you're trying to search through ${getEmptyStateText()} directly, ` +
                                "try using the main search bar above."
                            }
                            title="No filters match!"
                        />
                    )}
                    {this.props.isAiSearchApplied
                        ? this.renderAiSearchAppliedFilterGroups()
                        : this.renderFilterGroups()}
                </div>
            </div>
        )
    }
}
